module.exports = __webpack_public_path__ + "img/89.2b2f8710.webp";